<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nuevo contrato</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs4 px-2>
            <v-select v-model="contractType" :items="contractTypeItems" :error-messages="contractTypeErrors" label="Tipo"
                      required @change="$v.contractType.$touch()" no-data-text="No hay datos disponibles"></v-select>
          </v-flex>
          <v-flex xs4 pr-2>
            <DatePickerForm v-model="startDate" label="Fecha de inicio" :error-messages="startDateErrors"></DatePickerForm>
          </v-flex>
          <v-flex xs4 pr-2>
            <DatePickerForm v-model="endDate" label="Fecha de fin" :error-messages="endDateErrors"></DatePickerForm>
          </v-flex>
          <v-flex xs12 px-2>
            <transferencia-create v-if="$store.getters.isClubRole" v-show="isTransferLoaned" ref="transferenciaCreate"
              :isRequired="isTransferLoaned">
            </transferencia-create>
          </v-flex>
          <v-flex xs12 px-2 v-if="isTransferReceived">
            <v-text-field v-model="clubTo" :label="clubToLabel" @input="$v.clubTo.$touch()"
                          :error-messages="clubToErrors" v-show="isTransferReceived"></v-text-field>
          </v-flex>
          <v-flex xs12 px-2>
            <v-radio-group v-model="concepts" label="¿El Club tiene conceptos a su cargo?" v-show="isTransferLoaned" column row>
              <v-radio label="Sí" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 pr-2>
            <v-textarea v-model="comment" label="Comentario (opcional)"></v-textarea>
          </v-flex>
          <v-flex>
            <AttachFile ref="fileInput" @upload="uploadFiles" description single-file></AttachFile>
          </v-flex>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
          <a :href="asset.url" target="_blank" v-if="asset && !files.length" class="mr-2">Adjunto actual</a>
          <v-btn @click="openFileDirectory" color="primary" :disabled="saving">
            <span v-if="isEditing">Cambiar adjunto</span>
            <span v-else>Agregar adjunto</span>
          </v-btn>
          <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import TransferenciaCreate from '../components/TransferenciaCreate.vue'

const TRANSFER_LOANED = 2
const TRANSFER_RECEIVED = 3

export default {
  mixins: [validationMixin, s3UploadMixin, createEntityMixin],

  validations () {
    return {
      contractType: { required },
      startDate: { required },
      endDate: { required },
      clubTo: { required: requiredIf(() => { return this.isTransferReceived }) },
      files: { required: requiredIf(() => { return !this.isEditing }) }
    }
  },

  components: {
    DatePickerForm,
    AttachFile,
    ConfirmationDialog,
    TransferenciaCreate
  },

  data () {
    return {
      comment: null,
      startDate: null,
      endDate: null,
      contractType: null,
      contractTypeItems: [],
      concepts: false,
      clubTo: '',
      asset: null,
      createPath: 'contract/new',
      editPath: `contract/${this.$route.params.idContract}`
    }
  },

  computed: {
    esTransferenciaEntreClubesLPF () {
      return this.isTransferLoaned && this.$refs.transferenciaCreate.clubPerteneceALPF
    },
    isEditing () {
      return this.$route.params.hasOwnProperty('idContract')
    },
    fileErrors () {
      return this.getRequiredErrors('files', 'Adjunto requerido.')
    },
    contractTypeErrors () {
      return this.getRequiredErrors('contractType')
    },
    clubToErrors () {
      return this.getRequiredErrors('clubTo')
    },
    startDateErrors () {
      return this.getRequiredErrors('startDate')
    },
    endDateErrors () {
      let errors = this.getRequiredErrors('endDate')
      if (this.$v['endDate'].$dirty && !this.isValidEndDate()) {
        errors.push('La fecha de fin debe ser posterior a la de inicio')
      }
      return errors
    },
    isTransfer () {
      return (this.isTransferLoaned || this.contractType === TRANSFER_RECEIVED)
    },
    isTransferLoaned () {
      return this.contractType === TRANSFER_LOANED
    },
    isTransferReceived () {
      return this.contractType === TRANSFER_RECEIVED
    },
    clubToLabel () {
      return this.contractType === TRANSFER_LOANED ? 'Club destino' : 'Club de origen'
    },
    clubDestino () {
      return this.$refs.transferenciaCreate.clubDestino
    },
    esTransferenciaEntreClubesNoLPF () {
      return this.isTransferLoaned && !this.$refs.transferenciaCreate.clubPerteneceALPF
    },
    clubDestinoNoLpf () {
      return this.$refs.transferenciaCreate.clubDestinoNoLpf
    }
  },

  methods: {
    fetchContractTypes () {
      const path = `player/${this.$route.params.id}/contract-types`
      this.axios
        .get(path)
        .then(response => {
          this.contractTypeItems = response.data.estados
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      let payload = {
        'player': this.$route.params.id,
        'start_date': this.startDate,
        'end_date': this.endDate,
        'contract_type': this.contractType,
        'asset': this.assets,
        'comment': this.comment ? this.comment : ''
      }
      if (this.esTransferenciaEntreClubesLPF) {
        payload.clubLpfDestino = this.clubDestino
        payload.has_concepts = this.concepts
      } else if (this.isTransferReceived) {
        payload.club_to = this.clubTo
        payload.has_concepts = false
      } else if (this.esTransferenciaEntreClubesNoLPF) {
        payload.club_to = this.clubDestinoNoLpf
        if (this.isTransferLoaned) {
          payload.has_concepts = this.concepts
        } else {
          payload.has_concepts = false
        }
      } else {
        payload.club_to = ''
        payload.hasConcepts = false
      }
      return payload
    },
    setData (data) {
      this.startDate = this.formatDate(data.startDate)
      this.endDate = this.formatDate(data.endDate)
      this.clubTo = data.clubTo
      this.concepts = data.hasConcepts
      this.contractType = this.contractTypeItems.find(x => x.text === data.contractType).value
      this.asset = data.asset
    },
    isValidEndDate () {
      return this.startDate && this.endDate && (this.endDate > this.startDate)
    },
    isValidForm () {
      if (this.$refs.transferenciaCreate) {
        this.$refs.transferenciaCreate.$v.$touch()
      }
      let files = this.getFiles()
      for (const i in files) {
        let nameLength = files[i].name.length
        if (nameLength > 120) {
          this.$store.commit('setCustomErrorMsg', 'Nombre del archivo demasiado largo.')
          return false
        }
      }
      return (!this.$v.$invalid) && this.isValidEndDate()
    }
  },
  created () {
    this.fetchContractTypes()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.selector-club-lpf {
  width: 100%;
  margin-left: 1em;
}
</style>
